module.exports = __webpack_public_path__ + "img/avatar1.d3c6b5e4.png";